export const ExpensesListingMutations = {
  SetExpensesSearchParam: 'setExpensesSearchParam',
  SetExpensesLoading: 'setExpensesLoading',
  SetExpensesFilters: 'setExpensesFilters',
  SetExpensesSortOrder: 'setExpensesSortOrder',
  SetExpensesBulkActionValue: 'setExpensesBulkActionValue',
  SetExpensesModifiedWithBulkAction: 'setExpensesModifiedWithBulkAction',
  UpdateSelectedExpenses: 'updateSelectedExpenses',

  RetrieveExpensesAssignmentsSuccess: 'retrieveExpensesAssignmentsSuccess',
  RetrieveExpensesContractorsSuccess: 'retrieveExpensesContractorsSuccess',
  RetrieveExpensesSuccess: 'retrieveExpensesSuccess',
  RetrieveExpensesStatusCountsSuccess: 'retrieveExpensesStatusCountsSuccess',
  ResetExpensesState: 'resetExpensesState',
  UpdateExpensesPaginationParameters: 'updateExpensesPaginationParameters',
  ResetExpensesPaginationOffset: 'resetExpensesPaginationOffset',
  SetExpensesFilteredSortedRecordCount: 'setExpensesFilteredSortedRecordCount',
  SetBatchExpensesList: 'setBatchExpensesList'
};

export const ExpensesListingActions = {
  SetExpensesFilters: 'setExpensesFilters',
  SetExpensesSortOrder: 'setExpensesSortOrder',
  ExportExpensesAsExcel: 'exportExpensesAsExcel',
  DoExpensesBulkAction: 'doExpensesBulkAction',
  SetExpensesBulkAction: 'setExpensesBulkAction',
  SelectExpense: 'selectExpense',
  IsExpenseSelected: 'isExpenseSelected',
  SelectDeselectAllExpenses: 'selectDeselectAllExpenses',
  UpdateExpensesSearchParam: 'updateExpensesSearchParam',

  RetrieveExpensesAssignments: 'retrieveExpensesAssignments',
  RetrieveExpensesContractors: 'retrieveExpensesContractors',
  RetrieveExpenses: 'retrieveExpenses',
  RetrieveExpensesStatusCounts: 'retrieveExpensesStatusCounts',
  SetInitialExpensesState: 'setInitialExpensesState',
  SetExpensesPaginationParameters: 'setExpensesPaginationParameters',
  RetrieveExpensesFilteredSortedRecordCount: 'retrieveExpensesFilteredSortedRecordCount',
  RetrieveExpensesSearchRecordCount: 'retrieveExpensesSearchRecordCount',
  SetBatchExpensesList: 'setBatchExpensesList'
};

export const ExpensesListingGetters = {
  ExpensesSearchParam: 'expensesSearchParam',
  SelectedExpenses: 'SelectedExpenses',
  ModifiedExpenses: 'ModifiedExpenses',
  ExpensesPerPage: 'ExpensesPerPage',
  ExpensesListingOffset: 'ExpensesListingOffset',
  ExpensesFilteredSortedRecordCount: 'ExpensesFilteredSortedRecordCount',
  ExpensesContractors: 'getExpensesContractors',
  ExpenseIsLoading: 'ExpenseIsLoading',
  GetBatchExpensesList: 'GetBatchExpensesList'
};
